import React, { useState } from 'react';
import axios from 'axios';

const API_BASE = '';

function SearchComponent({ onSelectVehicle }) {
  const [vin, setVin] = useState('');
  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!vin.trim()) return;
    
    setLoading(true);
    setError('');
    try {
      const res = await axios.get(`${API_BASE}/api/vehicle/${vin}`);
      setVehicle(res.data);
      onSelectVehicle(res.data);
    } catch (err) {
      setError('VIN not found in database');
      setVehicle(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vin-search-section">
      <h2>🔍 Search by VIN</h2>
      <p className="search-desc">Find a specific vehicle by its VIN (17-digit identifier)</p>
      
      <form onSubmit={handleSearch} className="vin-search-form">
        <input
          type="text"
          placeholder="Enter VIN (e.g., 5NEP34AB3FH200000)"
          value={vin}
          onChange={(e) => setVin(e.target.value.toUpperCase())}
          className="vin-input"
          maxLength="17"
        />
        <button type="submit" className="search-btn" disabled={loading}>
          {loading ? 'Searching...' : 'Search VIN'}
        </button>
      </form>

      {error && <div className="error-msg">❌ {error}</div>}
      
      {vehicle && (
        <div className="vin-result">
          <h3>✅ Vehicle Found</h3>
          <div className="result-details">
            <div className="detail-row">
              <span>VIN:</span>
              <strong>{vehicle.vin}</strong>
            </div>
            <div className="detail-row">
              <span>Year:</span>
              <strong>{vehicle.year}</strong>
            </div>
            <div className="detail-row">
              <span>Make:</span>
              <strong>{vehicle.make}</strong>
            </div>
            <div className="detail-row">
              <span>Complaints:</span>
              <strong>{vehicle.complaint_count}</strong>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchComponent;
